/**
 * Original work Copyright (c) 2019 Burst Apps Team
 */

/**
 * Constants for payment subtypes
 *
 * @category transaction-types
 */
export enum TransactionPaymentSubtype {
    Ordinary = 0,
    MultiOut,
    MultiOutSameAmount,
}

